import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/home/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    meta: { title: "Alliance - Inteligencia contable" },
    component: Home
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   meta: { title: "Sobre mí" },
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "../views/About.vue"),
  // }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title}`;
  next();
});

export default router;
